import React from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import { loginAction, doPreProcess } from '../../rootStore';
import { setShowPropertyTransAnim } from '../../actions';
import { detector } from '../../lib/util/Detect';
import { Login } from '../index';
import './index.scss';

class Integral extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  // 收益记录
	toIncome = (tab) => {
	  this.Log && this.Log.sendClick({
	    element_type: 'total_property',
	    element_name: `total_${tab}`,
	  });
	  this.props.history.push({ pathname: '/incomeRecord', state: {
	    tab,
	  } });
	}

	stopPropertyTransAnim() {
	  this.props.dispatch(setShowPropertyTransAnim({
	    amountDiff: 0,
	    integralDiff: 0,
	  }));
	}

	render() {
	  const { amount = 0, integral = 0 } = this.props.myIntegral;
	  const {
	    integralDiff = 0,
	    amountDiff = 0,
	  } = this.props.propertyTransAnim;

	  const descText = detector.app.kuaibao ? '无提现门槛' : '去提现';

	  return (
      <>
        {this.props.isLogin
          ? <div className="propertyWrap">
            <div className="coinInfo">
              <div className="money coinItem" onClick={() => doPreProcess(this.toIncome)('cash')}>
                  <CountUp
                    start={amount - amountDiff}
                    end={amount}
                    decimals={2}
                    delay={0}
                    onStart={this.stopPropertyTransAnim.bind(this)}
                    onEnd={this.stopPropertyTransAnim.bind(this)}>
                    {({ countUpRef }) => (
                      <div className="moneyInfo">
                        <span className="num" ref={countUpRef} />
                        <span>元</span>
                      </div>
                    )}
                  </CountUp>
                <div className="moneyTip">{descText}<span className="arrow"></span></div>
              </div>
              <div className="coin coinItem" onClick={() => doPreProcess(this.toIncome)('coin')}>
                <div className="moneyInfo">
                    <CountUp
                      start={integral - integralDiff}
                      end={integral}
                      delay={0}
                      onStart={this.stopPropertyTransAnim.bind(this)}
                      onEnd={this.stopPropertyTransAnim.bind(this)}>
                      {({ countUpRef }) => (
                        <>
                          <span className="num" ref={countUpRef} />
                          <span>金币</span>
                        </>
                      )}
                    </CountUp>
                </div>
                <div className="moneyTip">兑换现金<span className="arrow"></span></div>
              </div>
            </div>
          </div>
          : (
            <Login onClickAction={loginAction.bind(this)}></Login>
          )
        }
      </>
	  );
	}
}

const mapStateToProps = (state) => {
  const { dialogs, signTask, kbApp, isLogin, preProcess, propertyTransAnim, myIntegral } = state;
  return {
    dialogs,
    signTask,
    kbApp,
    isLogin,
    preProcess,
    propertyTransAnim,
    myIntegral,
  };
};

export default connect(mapStateToProps)(Integral);
